import React, { useCallback, useState } from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';

import UserVerificationModal from 'components/user-verification-modal';
import useUserHasToVerify from 'hooks/use-user-has-to-verify';

import { ScanAndPayLayout } from '../components/scan-and-pay-layout';

import { AddNewPaymentButton, Description } from './no-payment-method.styled';
import { INoPaymentMethod } from './types';

export const NoPaymentMethod = ({
  bodyText,
  addPaymentMethodButtonText,
  openAddPaymentMethodModal,
  ...props
}: INoPaymentMethod) => {
  const headerElement = <Icon icon="paymentCard" color="icon-default" width="32px" aria-hidden />;

  const [showVerificationModal, setShowVerificationModal] = useState(false);

  const userHasToVerify = useUserHasToVerify();

  const handleAddNewPaymentMethod = useCallback(() => {
    if (userHasToVerify) {
      setShowVerificationModal(true);
    } else {
      openAddPaymentMethodModal();
    }
  }, [openAddPaymentMethodModal, userHasToVerify]);

  return (
    <ScanAndPayLayout headerElement={headerElement} {...props}>
      <>
        <Description content={bodyText} />
        <AddNewPaymentButton
          onClick={handleAddNewPaymentMethod}
          data-testid="button-add-new-payment-method"
        >
          {addPaymentMethodButtonText}
        </AddNewPaymentButton>
        {showVerificationModal && (
          <UserVerificationModal onDismiss={() => setShowVerificationModal(false)} />
        )}
      </>
    </ScanAndPayLayout>
  );
};
